import { Box, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { colors } from '@scriptpad/shared';
import { StepPaper } from './StepPaper.js';
import type { WizardStepProps } from './WizardRouter.js';

export const Step7Complete = (_props: WizardStepProps) => (
  <StepPaper sx={{ textAlign: 'center' }}>
    <Stack spacing={3} alignItems="center">
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          bgcolor: `${colors.green}22`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 56, color: colors.green }} />
      </Box>
      <Typography variant="h3">Onboarding completed</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480 }}>
        Thank you - your onboarding has been completed and is presently being reviewed by our team. We will
        process your registration and you will receive an email to set up your ScriptPad account. This
        usually takes 24-48 hours to complete.
      </Typography>
    </Stack>
  </StepPaper>
);
